export default __webpack_public_path__ + "static/media/fine_art_4.a9e401ba.jpg";